import React from 'react';
import mapImg from '../../../assets/map.png';

type Props = {
  colors: any;
  onOpenFullMap: () => void;
};

// Persian digits helper (۰-۹)
const toFaDigits = (v: unknown): string => {
  if (v === null || v === undefined) return '';
  return String(v)
    .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)])
    .replace(/\./g, '٫')
    .replace(/,/g, '٬');
};

const MapCard: React.FC<Props> = ({ colors, onOpenFullMap }) => {
  // 👇 only addition — control map height
  const MAP_HEIGHT = 320; // ← tweak this value (e.g., 280–360) to resize the map

  const card: React.CSSProperties = {
    background: colors.panel,
    border: `1px solid ${colors.border}`,
    borderRadius: 16,
    padding: 16,
    boxShadow: '0 6px 20px rgba(0,0,0,.25)',
    display: 'grid',
    placeItems: 'center',
    cursor: 'zoom-in',
  };

  const cardTitle: React.CSSProperties = {
    fontWeight: 800,
    marginBottom: 4,
    letterSpacing: 0.2,
    color: colors.text,
    textAlign: 'center',
  };

  const legendStyle: React.CSSProperties = {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 10,
    color: colors.sub,
  };

  return (
    <section style={card} onClick={onOpenFullMap} dir="rtl">
      <div
        style={{
          textAlign: 'center',
          color: colors.sub,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        {/* Header */}
        <div style={cardTitle}>نقشه ایزولیشن زنده</div>

        {/* 🔽 راهنما زیر تیتر */}
        <div style={legendStyle}>
          راهنما:
          <span style={{ color: '#10B981', marginRight: 8 }}>رنگ سبز: نصب شده</span> •
          <span style={{ color: '#F59E0B', marginRight: 8 }}>رنگ زرد: در حال نصب یا برداشت</span> •
          <span style={{ color: '#EF4444', marginRight: 8 }}>رنگ قرمز: برداشته شده</span>
        </div>

        {/* Map Container */}
        <div
          style={{
            height: MAP_HEIGHT, // 👈 replaced flex: 1 with fixed height
            border: '1px dashed rgba(255,255,255,0.18)',
            borderRadius: 12,
            overflow: 'hidden',
            background: '#0b1220',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
        >
        <img
  src={mapImg}
  alt="نقشه ایزولیشن زنده"
  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 12,
    transition: 'transform 0.25s ease',
    transform: 'scale(1.10)', // 🧩 stronger base zoom
    willChange: 'transform',
  }}
  onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.11)')}
  onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1.08)')}
/>


        </div>
      </div>
    </section>
  );
};

export default MapCard;
